import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { fg } from '@confluence/feature-gating';

export const useSmartButtonPremiumGate = () => {
	const { edition } = useSessionData();

	const isPremium = edition === ConfluenceEdition.PREMIUM;

	return {
		isSmartButtonAllowed: isPremium || fg('a4c_free_and_standard_editions'),
	};
};
